export default __webpack_public_path__ + "static/media/EAH-AZ60.39572515.jpg";